import { render, staticRenderFns } from "./compareHeader.vue?vue&type=template&id=298f283a&scoped=true"
import script from "./compareHeader.vue?vue&type=script&lang=js"
export * from "./compareHeader.vue?vue&type=script&lang=js"
import style0 from "./compareHeader.vue?vue&type=style&index=0&id=298f283a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298f283a",
  null
  
)

export default component.exports